export enum SkipTraceScope {
  CONTACT = "CONTACT",
  CONTACT_LIST = "CONTACT_LIST",
  SELECTION = "SELECTION",
}
